/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useTranslation } from "react-i18next";
import { COLORS } from "./layout.constants";
import useIsMobile from "./useIsMobile";
import "./PageContainer.css";

export default function PageContainer({ children, title }) {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const isMobile = useIsMobile();

  return (
    <div
      className="d-flex justify-content-center align-items-center page-container-wrapper"
      style={{
        background: COLORS.gradient,
        fontFamily: "'Tajawal', 'Cairo', sans-serif",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <div
        className="page-container-card animate__animated animate__fadeInUp"
        style={{
          background: "rgba(255,255,255,0.08)",
          border: "1px solid rgba(255,255,255,0.15)",
          color: "#fff",
          padding: isMobile ? "30px 20px" : "40px 30px",
        }}
      >
        {title && (
          <h3
            className="fw-bold mb-3 text-center"
            style={{
              color: COLORS.gold,
              fontSize: "1.8rem",
              fontFamily: "'Cairo', sans-serif",
            }}
          >
            {title}
          </h3>
        )}

        {children}
      </div>
    </div>
  );
}
